import { propertyBeingSoldCard as basePropertyBeingSoldCard } from '../../../offer/cards';
import { applyOverrides } from '../../../shared';

export const propertyBeingSoldCard = applyOverrides(basePropertyBeingSoldCard, {
  id: 'propertyInfo.propertyBeingLeased',
  innerTitle: 'Property Being Leased',
});
